export const InterviewFactory = (() => {
    const Factory = function () {
        const self = this;

        const formatUTCOffset = (offsetInMinutes) => {
            const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
            const minutes = Math.abs(offsetInMinutes) % 60;
            const sign = offsetInMinutes >= 0 ? '+' : '-';
            
            if (minutes === 0) {
                return `GMT ${sign}${hours}`;
            } else {
                return `GMT ${sign}${hours}:${String(minutes).padStart(2, '0')}`;
            }
        };

        const getUserTimeZoneInfo = () => {
            const currentOffset = moment().utcOffset();
            return {
                format: formatUTCOffset(currentOffset),
                offset: currentOffset
            };
        };

        const getBrandTimeZoneInfo = (timeZoneName) => {
            if (!timeZoneName) {
                return getUserTimeZoneInfo();
            }
            
            const offsetInMinutes = moment().tz(timeZoneName).utcOffset();
            return {
                format: formatUTCOffset(offsetInMinutes),
                offset: offsetInMinutes
            };
        };

        self.getBrandTimeZoneDetails = async (brandId) => {
            try {
                const response = await CoreReaderAPI.getBrandTimeZoneDetails(brandId);
                const userTimeZone = getUserTimeZoneInfo();
                const brandTimeZone = getBrandTimeZoneInfo(response.timezone?.name);
                
                return {
                    brand: brandTimeZone,
                    user: userTimeZone
                };
            } catch (error) {
                console.error(error, "error");
            }
        };

        return self;
    };

    Factory.$inject = [];

    return Factory;
})();